import React from 'react'

import { FlowChartStatRow } from 'common/builder/components/chart/FlowChart/types/FlowChartStatRow'

import { NodeStatsRow } from './NodeStatsRow/NodeStatsRow'

interface NodeStatsProps {
  rows: FlowChartStatRow[]
}

export const NodeStats = React.memo(({ rows }: NodeStatsProps) => {
  return (
    <>
      {rows.map((row, index) => (
        <NodeStatsRow key={index} row={row} />
      ))}
    </>
  )
})
